module.exports = __webpack_public_path__ + "static/media/16UNODC32.e36a2e0b.jpg";